import { ChemicalMeta, ChemicalType } from '../types';

export const CHEMICALS: Record<ChemicalType, ChemicalMeta> = {
  alum: {
    id: 'alum',
    nameTh: 'สารส้ม',
    nameEn: 'Alum',
    unit: 'ตัน (Tons)',
    color: {
      primary: '#2563eb', // blue-600
      bg: '#eff6ff',      // blue-50
      border: '#bfdbfe',  // blue-200
      text: '#1d4ed8',    // blue-700
      badge: 'bg-blue-100 text-blue-800 border-blue-200',
    },
    fields: {
      income: 'alum_income',
      usage: 'alum_tons_total',
      stock: 'alum_stock_2400',
    },
  },
  pac: {
    id: 'pac',
    nameTh: 'โพลีอะลูมิเนียมคลอไรด์',
    nameEn: 'PAC',
    unit: 'ตัน (Tons)',
    color: {
      primary: '#059669', // emerald-600
      bg: '#ecfdf5',      // emerald-50
      border: '#a7f3d0',  // emerald-200
      text: '#047857',    // emerald-700
      badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    },
    fields: {
      income: 'pac_income',
      usage: 'pac_tons_total',
      stock: 'pac_stock_2400',
    },
  },
  chl: {
    id: 'chl',
    nameTh: 'คลอรีน',
    nameEn: 'Chlorine',
    unit: 'ตัน (Tons)',
    color: {
      primary: '#d97706', // amber-600
      bg: '#fffbeb',      // amber-50
      border: '#fde68a',  // amber-200
      text: '#b45309',    // amber-700
      badge: 'bg-amber-100 text-amber-800 border-amber-200',
    },
    fields: {
      income: 'chl_income',
      usage: 'chl_tons_total',
      stock: 'chl_stock_2400',
    },
  },
  poly: {
    id: 'poly',
    nameTh: 'โพลิเมอร์',
    nameEn: 'Polymer',
    unit: 'ตัน (Tons)',
    color: {
      primary: '#7c3aed', // violet-600
      bg: '#f5f3ff',      // violet-50
      border: '#ddd6fe',  // violet-200
      text: '#6d28d9',    // violet-700
      badge: 'bg-violet-100 text-violet-800 border-violet-200',
    },
    fields: {
      income: 'poly_income',
      usage: 'poly_tons_total',
      stock: 'poly_stock_2400',
    },
  },
};

export const CHEMICAL_LIST: ChemicalMeta[] = Object.values(CHEMICALS);
